const PRINT_PLAN_LABEL_OUTPUT_SELECTOR = '[data-plan-label-output-scale]';
const appliedScaleCache = new WeakMap();

function positiveNumber(value, fallback = 1) {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : fallback;
}

function printPlanLabelOutputScale(options = {}) {
  const referencePx = positiveNumber(options.referencePx);
  const renderedPx = positiveNumber(options.renderedPx);
  const contentScale = positiveNumber(options.contentScale);
  const outputUnitsPerCssPx = positiveNumber(options.outputUnitsPerCssPx);
  return (referencePx * outputUnitsPerCssPx) / (renderedPx * contentScale);
}

function outputScaleForVisual(visual, options = {}) {
  return printPlanLabelOutputScale({
    referencePx: visual?.getAttribute?.('data-plan-label-reference-px'),
    renderedPx: visual?.getAttribute?.('data-plan-label-rendered-px'),
    contentScale: options.contentScale,
    outputUnitsPerCssPx: options.outputUnitsPerCssPx
  });
}

function applyPrintPlanLabelOutputScale(root, options = {}) {
  if (!root?.querySelector || !root?.querySelectorAll) return 0;
  const contentScale = positiveNumber(options.contentScale);
  const outputUnitsPerCssPx = positiveNumber(options.outputUnitsPerCssPx);
  const firstVisual = root.querySelector(PRINT_PLAN_LABEL_OUTPUT_SELECTOR);
  if (!firstVisual) {
    appliedScaleCache.delete(root);
    return 0;
  }

  const signature = `${contentScale}|${outputUnitsPerCssPx}`;
  const cached = appliedScaleCache.get(root);
  if (cached?.signature === signature && cached.firstVisual === firstVisual) return 0;

  const visuals = root.querySelectorAll(PRINT_PLAN_LABEL_OUTPUT_SELECTOR);
  let updated = 0;
  for (const visual of visuals) {
    const scale = outputScaleForVisual(visual, { contentScale, outputUnitsPerCssPx });
    visual.setAttribute('transform', `scale(${scale})`);
    visual.setAttribute('data-plan-label-output-factor', scale);
    updated += 1;
  }
  appliedScaleCache.set(root, { signature, firstVisual });
  return updated;
}

export {
  PRINT_PLAN_LABEL_OUTPUT_SELECTOR,
  applyPrintPlanLabelOutputScale,
  printPlanLabelOutputScale
};
